import { css } from "@emotion/react"

import { colorsCP, fontsCP } from "../../Tokens"

export const iqForm = css`
.iq-field-base {
  font-family: ${ fontsCP["font-primary"]["font-family"]};
	margin-bottom: 24px;

  &__required,
  &__error-message {
		padding: 0;
		margin: 0;
		line-height: 20px;
		color: ${colorsCP["error-50"]};
  }
}

// base input field
.iq-input-field {
	&__input {
		border: 1px solid ${colorsCP["neutral-50"]};
		border-radius: 8px;

    &:focus {
			outline-color: ${colorsCP["blue-40"]};
    }

		&::selection {
			background-color: ${colorsCP["emerald-40"]};
			color: ${colorsCP["neutral-00"]};
    }

		&::placeholder {
			color: neutral-30;
    }
  }

  &--invalid, &.error {
    .iq-input-field__input {
      border: 1px solid ${colorsCP["error-50"]};
    }
  }

  &__dropdown {
		background-color: ${colorsCP["neutral-00"]};
  }

  &__dropdown-icon-holder {
		color: ${colorsCP["neutral-50"]};
  }
}

// password field
.iq-password-field {
	.iq-input-field__input {
		color: ${colorsCP["neutral-50"]};
  }
}

// select field
.iq-select-field {
	&__input {
		border: 1px solid ${colorsCP["neutral-50"]};

    &__input[placeholder] {
			color: ${colorsCP["neutral-50"]};

			&:disabled {
				color: ${colorsCP["neutral-50"]};
      }
    }

		&:invalid {
			color: ${colorsCP["error-50"]};
    }
  }

  &--empty {
		.iq-select-field__input {
			color: ${colorsCP["neutral-50"]};
    }
  }

	&--invalid, &.error {
		.iq-select-field__input {
			border: 1px solid ${colorsCP["error-50"]};

			&:focus {
				outline-color: ${colorsCP["error-50"]};
      }
    }
  }

	&--disabled {
		.iq-select-field__input {
			border: 1px solid ${colorsCP["neutral-50"]};
			background-color: ${colorsCP["neutral-20"]};
			color: ${colorsCP["neutral-50"]};
    }
  }

	&__select-holder {
		background-color: ${colorsCP["neutral-00"]};
  }
}

.iq-checkbox-field {
	font-family: ${ fontsCP["font-primary"]["font-family"]};

	&--disabled {
		color: ${colorsCP["neutral-50"]};
  }

  &__icon {
    background-color: ${colorsCP["neutral-00"]};
    border: 1px solid ${colorsCP["neutral-50"]};
  }

  &--invalid, &.error {
    .iq-checkbox-field__icon {
      border-color: ${colorsCP["error-50"]};
    }
  }

  &--disabled {
    .iq-checkbox-field__icon {
      background-color: ${colorsCP["neutral-20"]};
      border-color: ${colorsCP["neutral-50"]};
    }

    .iq-checkbox-field__icon:after {
      border-color: ${colorsCP["neutral-50"]};
    }
    .iq-checkbox-field__input {
      &:checked ~ .iq-checkbox-field__icon {
        background-color: ${colorsCP["neutral-20"]};
        border-color: ${colorsCP["neutral-50"]};
      }
    }
  }
}
.iq-radio-field {
  font-family: ${ fontsCP["font-primary"]["font-family"]};

  &--disabled {
		.iq-radio-field__option-holder {
			color: ${colorsCP["neutral-50"]};
    }
  }
	&__icon {
		border: 1px solid ${colorsCP["neutral-50"]};

		&:after {
			border: 1px solid ${colorsCP["neutral-50"]};
    }
  }
  &--disabled {
    .iq-radio-field__icon, .iq-radio-field__icon:after {
      border-color: ${colorsCP["neutral-50"]};
    }
  }

  &--invalid, &.error {
    .iq-radio-field__icon:after {
			color: ${colorsCP["neutral-50"]};
    }
  }

  &--disabled {
		.iq-radio-field__input {
			&:checked ~ .iq-radio-field__icon {
				border-color: ${colorsCP["neutral-50"]};
      }

			&:checked ~ .iq-radio-field__icon:after {
				border-color: ${colorsCP["neutral-50"]};
      }
    }
  }
}

// textarea field
.iq-textarea-field {
  &__input {
		border: 1px solid ${colorsCP["neutral-50"]};

    &::selection {
			background-color: ${colorsCP["blue-50"]};
			color: ${colorsCP["neutral-00"]};
    }

		&::placeholder {
			color: ${colorsCP["neutral-50"]};
    }
}
  &--invalid, &.error {
		.iq-textarea-field__input {
			border: 1px solid ${colorsCP["error-50"]};

			&:focus {
				outline-color: ${colorsCP["error-50"]};
      }
    }
  }

	&--disabled {
		.iq-textarea-field__input {
			border: 1px solid ${colorsCP["neutral-50"]};
			background-color: ${colorsCP["neutral-20"]};
			color: ${colorsCP["neutral-50"]};

			&::placeholder {
				color: ${colorsCP["neutral-50"]};
      }
    }
  }
}
`
